package fr.frux.core.designsystem.components

/**
 * Libellés français des mois et des périodes de récolte, séparés de [SeasonStrip] (pur Kotlin,
 * sans Compose) pour rester testables sans runtime UI.
 */

private val monthNamesShort = listOf(
    "janv.", "févr.", "mars", "avr.", "mai", "juin",
    "juil.", "août", "sept.", "oct.", "nov.", "déc.",
)

/** Nom court français d'un mois (1..12), ex. "janv.", "août". */
fun monthShortFr(month: Int): String {
    require(month in 1..12) { "month doit être dans 1..12, reçu $month" }
    return monthNamesShort[month - 1]
}

/**
 * Mois dont le nom court commence par une voyelle et prend donc l'élision "d'" plutôt que "de"
 * (avril, août, octobre).
 */
private val elidedMonths = setOf(4, 8, 10)

private fun monthPreposition(month: Int): String = if (month in elidedMonths) "d'" else "de "

/**
 * Libellé de période de récolte à partir des mois de début et de fin (1..12).
 * Même mois : "Récolte en juin". Mois différents : "Récolte de sept. à oct." (élision "d'" pour
 * avril/août/octobre : "Récolte d'oct. à févr.").
 */
fun harvestPeriodLabel(monthStart: Int, monthEnd: Int): String {
    require(monthStart in 1..12) { "monthStart doit être dans 1..12, reçu $monthStart" }
    require(monthEnd in 1..12) { "monthEnd doit être dans 1..12, reçu $monthEnd" }
    return if (monthStart == monthEnd) {
        "Récolte en ${monthShortFr(monthStart)}"
    } else {
        "Récolte ${monthPreposition(monthStart)}${monthShortFr(monthStart)} à ${monthShortFr(monthEnd)}"
    }
}

/** Libellé "Jusqu'à fin <mois>", ex. "Jusqu'à fin oct.". */
fun untilEndOfLabel(monthEnd: Int): String {
    require(monthEnd in 1..12) { "monthEnd doit être dans 1..12, reçu $monthEnd" }
    return "Jusqu'à fin ${monthShortFr(monthEnd)}"
}
